import React from 'react';
import IntlMessage from "../../../../../../components/IntlMessage/IntlMessage";

export const STEP_ITEMS = [
    {
        key: 1,
        title: <IntlMessage id={'micro.generalInfo'}/>,
    },
    {
        key: 2,
        title: <IntlMessage id={'micro.generalInfo'}/>,
    },
    {
        key: 3,
        title: <IntlMessage id={'micro.epTasks'}/>,
    },
    {
        key: 4,
        title: <IntlMessage id={'micro.epCompetences'}/>,
    },
    {
        key: 5,
        title: <IntlMessage id={'micro.resultsEd'}/>,
    },
    {
        key: 6,
        title: <IntlMessage id={'micro.matrix'}/>,
    },
    {
        key: 7,
        title: <IntlMessage id={'micro.disciplines'}/>,
    },
    {
        key: 8,
        title: <IntlMessage id={'micro.authorsAndDevs'}/>,
    },
];
